import type { FC } from 'react'
import { useMemo } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { twJoin } from 'tailwind-merge'

import Highlight from '@/components/Highlight'
import type { Department } from '@/modules/admin/resources'

export const DepartmentsListItem: FC<
  Department & { searchFilter: string; onClickDepartmentRow: () => void }
> = ({
  code,
  name,
  project,
  deputyUser,
  user,
  customer,
  searchFilter,
  inactive,
  onClickDepartmentRow,
}) => {
  const { deputyText, userText } = useMemo(() => {
    const userText = user ? `${user.firstName} ${user.lastName}` : ''
    const deputyText = deputyUser ? `${deputyUser.firstName} ${deputyUser.lastName}` : ''
    return { userText, deputyText }
  }, [deputyUser, user])

  const className = inactive ? 'text-[#919191]' : ''

  return (
    <tr
      className={twJoin('hover:cursor-pointer hover:bg-[#f0f0f0]', className)}
      onClick={() => onClickDepartmentRow()}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter') onClickDepartmentRow()
      }}
    >
      <Td>
        <Highlight pattern={searchFilter} text={code} />
      </Td>
      <Td>
        <Highlight pattern={searchFilter} text={name} />
      </Td>
      <Td className="hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={project} />
      </Td>
      <Td className="hidden sm:table-cell">
        <div>
          <Highlight pattern={searchFilter} text={userText} />
        </div>
        <div className="mt-1.5 hidden text-sm text-gray-500 md:table-cell">
          <Highlight pattern={searchFilter} text={deputyText} />
        </div>
      </Td>
      <Td className="hidden sm:table-cell">
        <Highlight pattern={searchFilter} text={customer?.name} />
      </Td>
    </tr>
  )
}
